import Icon from "~/components/shared/Icon";
import Button from "~/components/shared/Button";
import { ExampleSummary } from "~/components/shared/Examples/ExampleSummary";
import { Example } from "~/components/shared/Examples/useExamples";
import { exampleUrl } from "~/components/shared/Examples/utils";

export function ExampleDetail({ example, onBack }: { example: Example; onBack: () => void }) {
  return (
    <div className="divide-gray divide-y">
      <div className="px-1 py-1.5">
        <button
          onClick={onBack}
          className="flex h-7 items-center gap-1 rounded px-2 font-medium hover:bg-gray-200"
        >
          <Icon icon="heroicons/16/solid/arrow-left" className="block size-4" />
          Back
        </button>
      </div>

      <div className="space-y-3 p-3">
        <ExampleSummary example={example} />

        <Button href={exampleUrl(example)} theme="small" className="font-medium">
          Apply this example
        </Button>
      </div>
    </div>
  );
}
